import { Component, Injector, OnInit } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { forkJoin } from 'rxjs';
import { LocalService } from '@app/@core/services/local.service';
import { DataStoreService } from '@pics-core/dynamic';
import { ActivatedRoute, Router } from '@angular/router';
import { ComplaintFormService } from '../complaint-form.service';
interface TimelineItem {
  complaint_status: string;
  archival_status: string;
  date: string;
  name: string;
}

interface ApiTimelineItem {
  complaint_id: number;
  archival_status_value: string;
  complaint_status_value: string;
  created_date: string;
  person_id: number;
  is_active: boolean;
  created_by: number;
  created_name: string;
}

@Component({
  standalone: false,
  selector: 'app-complaint-flow-timeline',
  templateUrl: './complaint-flow-timeline.component.html',
  styleUrls: ['./complaint-flow-timeline.component.scss']
})
export class ComplaintFlowTimelineComponent implements OnInit {
  timelineData: TimelineItem[] = [];
  backgroundStatusOptions: any[] = [];
  personData: any = null;
  userData: any = null;
  complaintID: any = null;
  userID: any = null;
  createdByUser: any = null;
  injector: Injector;
  dataStore: DataStoreService;
  hidePreviousNextButtons: boolean = false;
  private userCache: Map<number, any> = new Map();
  constructor(
    private readonly httpService: HttpService,
    private readonly sessionStorage: LocalService,
    public router: Router,
    injector: Injector,
     private route: ActivatedRoute,
     private complaintFormService: ComplaintFormService
  ) {
    this.injector = injector;
    this.dataStore = injector.get<DataStoreService>(DataStoreService);
    this.checkReadOnlyModeToHidePreviousNextButton();
  }

  ngOnInit(): void {
    this.getComplaintIdFromSession();
    this.loadData();
  }

  private loadData(): void {
    if (!this.complaintID) {
      console.error('Complaint ID not found in session storage');
      this.timelineData = [];
      return;
    }

    console.log('Loading background case timeline data for complaintID:', this.complaintID);

   this.complaintFormService.getComplaintTimeLine({complaintId: this.complaintID}).subscribe({
      next: (results: any) => {

        const timelineResponse = results;

        if (timelineResponse.status === 'success' && timelineResponse.data?.data) {
          this.processTimelineData(
            Array.isArray(timelineResponse.data.data) ? timelineResponse.data.data : [timelineResponse.data.data]
          );
        } else {
          console.warn('No timeline data found or invalid response structure');
          this.timelineData = [];
        }
      },
      error: error => {
        console.error('Error loading background case timeline data:', error);
        this.timelineData = [];
      }
    });
  }


  private getComplaintIdFromSession(): void {
    const complaintIDString = this.sessionStorage.getItem('complaintId');
    this.complaintID = complaintIDString ? JSON.parse(complaintIDString) : null;
  }
  private processTimelineData(apiData: ApiTimelineItem[]): void {
    console.log('Processing background case timeline data:', apiData);

    // Sort by created_date in descending order (newest first/top, oldest last/bottom)
    const sortedData = apiData.sort((a, b) => {
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();
      return dateB - dateA; // Descending order: newest first, oldest last
    });

    // Fetch user data for all unique users and then process timeline
    const uniqueUserIds = [...new Set(sortedData.map(item => item.created_by))];
    this.fetchUserDataForIds(uniqueUserIds).then(() => {
      this.timelineData = sortedData.map(item => {
        const statusLabel = item.complaint_status_value;
        const statusLabel2 = item.archival_status_value;
        const formattedDate = this.formatDate(item.created_date);
        const personName = item.created_name;

        return {
          complaint_status: this.toTitleCase(statusLabel),
          archival_status: this.toTitleCase(statusLabel2),
          date: formattedDate,
          name: this.toTitleCase(personName)
        };
      });

      console.log('Processed background case timeline data:', this.timelineData);
    });
  }


  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ];

    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    const displayMinutes = minutes.toString().padStart(2, '0');

    return `${month} ${day}, ${year}, ${displayHours}:${displayMinutes} ${ampm}`;
  }


  private toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  }

  private fetchUserDataForIds(userIds: number[]): Promise<void> {
    const requests = userIds
      .filter(id => !this.userCache.has(id)) // Only fetch if not already cached
      .map(id =>
        this.httpService
          .get(`/application-flow/person?userId=${id}`)
          .toPromise()
          .then((response: any) => {
            if (response?.data) {
              this.userCache.set(id, response.data[0]);
            }
          })
          .catch((error: any) => {
            console.error(`Error fetching user data for userId ${id}:`, error);
            this.userCache.set(id, { first_name: 'Unknown', last_name: 'User' });
          })
      );

    return Promise.all(requests).then(() => {});
  }

  isSingleItem(): boolean {
    return this.timelineData.length === 1;
  }
  moveToNext() {
    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3732);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
      ? this.sessionStorage.getObj('parentGridPage')
      : {};
    let nextTab = null;
    let islastTab = null;
    if (currentTabIndex !== -1 && currentTabIndex == tabList.length - 1) {
      islastTab = tabList[currentTabIndex + 1] ? false : true;
    }
    currentTabIndex !== -1 ? (nextTab = tabList[currentTabIndex + 1]) : null;
    let lastTabId = null;
    if (islastTab) {
      lastTabId = tabList[currentTabIndex]?.id;
    }
    const nextTabIndex = currentTabIndex + 1;
    if (islastTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (nextTab && nextTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', { isRoute: true, nextPage: nextTabIndex, submissionId: null });
      return;
    } else {
      // this.location.back();
      return;
    }
  }
  moveToPrevious() {
    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3732);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
      ? this.sessionStorage.getObj('parentGridPage')
      : {};
    let previousTab = null;
    let isFirstTab = null;
    if (currentTabIndex === 0) {
      isFirstTab = true;
    }
    currentTabIndex > 0 ? (previousTab = tabList[currentTabIndex - 1]) : null;
    const previousTabIndex = currentTabIndex - 1;
    if (isFirstTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (previousTab && previousTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', {
        isRoute: true,
        nextPage: previousTabIndex,
        submissionId: null
      });
      return;
    } else {
      return;
    }
  }

  checkReadOnlyModeToHidePreviousNextButton() {
    let appMode = JSON.parse(this.sessionStorage.getItem('applicationmode'));
    let isReadOnlyMode = false;
    if (appMode === 'view') {
      isReadOnlyMode = true;
    }
    if (isReadOnlyMode) {
      this.hidePreviousNextButtons = true;
    }
  }
}
